import React, { Component } from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { Column, Button, TextInput } from '@resurs/midas-react'
import { getText } from '../../../../../internal/TextLabels'
import { PayApplyIdType } from '../../../../../models/payapply'
import IdentificationTypeSelector from '../../shared/IdentificationTypeSelector'

class PaymentIdentificationPageAnalogUI extends Component {
  constructor(props) {
    super(props)
    this.state = {
      refnr: null,
    }
    this.idType = PayApplyIdType.DRIVERS_LICENCE
  }

  setIdType(type) {
    this.idType = type
  }

  render() {
    const result = this.props.result
    return (
      <form
        onSubmit={e => {
          e.preventDefault()
          this.props.onNext({
            refnr: this.state.refnr,
            idType: this.idType,
          })
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: '1 1 100%',
            justifyContent: 'center',
            border: '1px solid lightgrey',
            padding: '2rem',
            marginTop: '2rem',
            fontSize: '2rem',
          }}
        >
          <div style={{ display: 'flex' }}>
            <Column col4 noPadding>
              {getText('payApply.sign.invoiceAmount')}
            </Column>
            <Column col8 noPadding>
              <NumberFormat
                value={result.payment.paymentStatus.totalOrderAmount}
                displayType="text"
                thousandSeparator=" "
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                renderText={val => getText('default.currency', val)}
              />
            </Column>
          </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '2rem' }}>
          <Column key="invoice" col6 noPadding>
            <IdentificationTypeSelector
              id="i-identification"
              onChange={value => this.setIdType(value)}
              label={getText('payApply.sign.idType')}
            />
            <TextInput
              id="i-id-type-refnr"
              label={getText('payApply.sign.refnr')}
              value={this.state.refnr ? this.state.refnr : ''}
              placeholder={getText('payApply.sign.refNrPlaceholder')}
              onChange={e => this.setState({ refnr: e.target.value })}
              autoFocus
              skipValidation
            />
          </Column>
          <Column key="invoice-button" col6 noPadding>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                height: '100%',
                paddingTop: '2rem',
              }}
            >
              <Button
                form
                type="primary"
                disabled={this.state.refnr === null}
                loading={this.props.newPageLoading}
              >
                {getText('payApply.identify.OK')}
              </Button>
            </div>
          </Column>
        </div>
      </form>
    )
  }
}

PaymentIdentificationPageAnalogUI.propTypes = {
  result: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  newPageLoading: PropTypes.bool.isRequired,
}

export default PaymentIdentificationPageAnalogUI
